import Vue from 'vue';

export default {

    namespaced: true,
    state: {
        formData: {}
    },
    mutations: {
        setFormDataField(state, { targetFieldPath, value }) {

            const properties = targetFieldPath.split('.');
            const lastIndex = properties.length - 1;

            let currentProp = state.formData;

            for (let propIndex = 0; propIndex < lastIndex; propIndex++) {
                var propName = properties[propIndex];
                if (!Object.prototype.hasOwnProperty.call(currentProp, propName) || currentProp[propName] == undefined) Vue.set(currentProp, propName, {})
                currentProp = currentProp[propName];
            }

            var lastProperty = properties[lastIndex];
            if (!Object.prototype.hasOwnProperty.call(currentProp, lastProperty) || Array.isArray(currentProp)) Vue.set(currentProp, lastProperty, value)
            else currentProp[lastProperty] = value;
        },
        resetFormData(state) {
            state.formData = {}
        }
    },
    actions: {},
    getters: {
        getFormData: (state) => state.formData,
    }
}